import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonRefresher, IonRefresherContent } from '@ionic/vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RefresherComponent',
  setup(__props) {

function handleRefresh() {
  window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonRefresher), {
    slot: "fixed",
    onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh()))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRefresherContent))
    ]),
    _: 1
  }))
}
}

})